import { useTranslation } from 'react-i18next';

import styles from './SplashScreen.module.css';

// PARA-105, AC-1: индикатор загрузки на время инициализации Telegram WebApp
// SDK и запроса аутентификации.
export function SplashScreen(): JSX.Element {
  const { t } = useTranslation('auth');

  return (
    <div className={styles.splash} role="status" aria-live="polite">
      {t('splash.loading')}
    </div>
  );
}
